import { escapeRegExp, get } from "lodash";

import { ITableDto } from "../dto";

interface IReportSearchMatcherArguments {
  row: ITableDto;
  visibleFieldNames: string[];
  searchValue: string;
}

export const reportSearchMatcher = ({
  row,
  visibleFieldNames,
  searchValue,
}: IReportSearchMatcherArguments): boolean => {
  if (!searchValue) {
    return true;
  }

  return visibleFieldNames?.some(fieldName =>
    Boolean(
      String(get(row, fieldName))
        .toLowerCase()
        .match(escapeRegExp(searchValue).toLowerCase()),
    ),
  );
};
